<template>
  <div
    class="packagePage aiPageBg"
    :class="imgData.length > 2 ? 'maxHeight' : ''"
  >
    <navbar :nav="nav"></navbar>
    <div class="packageContent">
      <div class="imgBox" v-if="imgData.length > 0">
        <div class="left" @click="prev" v-show="index != 0">
          <van-icon name="arrow-left" />
        </div>
        <div style="display: flex;">
          <div
            class="imgItem"
            :class="checkPack == index ? 'checkPackBox' : ''"
            @click="checkPackData(index, imgData[index])"
          >
            <img class="img" :src="imgData[index].packageImage" alt="" />

            <img
              class="check"
              v-if="checkPack == index"
              src="../../assets/img/icon/icon_check2.png"
            />
            <img
              class="new"
              v-if="index == 0"
              src="../../assets/img/icon/icon_new.png"
            />
          </div>
          <div
            class="imgItem"
            v-if="!notMore"
            :class="checkPack == index + 1 ? 'checkPackBox' : ''"
            @click="checkPackData(index + 1, imgData[index + 1])"
          >
            <img class="img" :src="imgData[index + 1].packageImage" alt="" />

            <img
              class="check"
              v-if="checkPack == index + 1"
              src="../../assets/img/icon/icon_check2.png"
            />
          </div>
        </div>
        <div class="right" @click="next" v-show="index < imgData.length - 2">
          <van-icon name="arrow" />
        </div>
      </div>
      <!-- <div class="imgBox">
        <div
          class="imgItem"
          v-for="(item, index) in imgData"
          :key="index"
          @click="checkPackData(index, item)"
        >
          <img class="img" :src="item.packageImage" />
          <img
            class="check"
            v-if="checkPack == index"
            src="../../assets/img/icon/icon_check2.png"
          />
          <img
            class="new"
            v-if="item.use"
            src="../../assets/img/icon/icon_new.png"
          />
        </div>
      </div> -->
      <div class="tagBox">
        <div class="text">{{ level.packageName }}</div>
        <div class="">
          <div class="items">
            <img class="icon" src="../../assets/img/icon/icon_dui.png" />
            <div>無料ダウンロード</div>
          </div>
          <div class="items">
            <img class="icon" src="../../assets/img/icon/icon_dui.png" />
            <div v-if="level.type == 0 || level.type == 3">
              毎日{{ level.generateNumber }}枚まで
            </div>
            <div v-if="level.type == 1">
              {{ level.toDay ? level.toDay : "1" }} 日以内
              {{ level.generateNumber }}枚生成可能
            </div>
            <div v-if="level.type == 2">
              {{ level.generateNumber }}枚生成可能
            </div>
            <!-- <div>毎日{{ generateNumber }}枚生成可能</div> -->
            <!-- generateNumber -->
          </div>
          <div class="items">
            <img class="icon" src="../../assets/img/icon/icon_dui.png" />
            <div>画像比率自由</div>
          </div>
          <div class="items">
            <img class="icon" src="../../assets/img/icon/icon_dui.png" />
            <div>ダウンロード無制限</div>
          </div>
        </div>
      </div>

      <van-button
        round
        block
        type="info"
        native-type="submit"
        class="buttonBlue"
        @click="
          taocanModel = true;
          savePack();
        "
        >プラン変更</van-button
      >
      <div class="taocanPopup" v-if="taocanModel">
        <div class="taocanContent">
          <div class="phone" @click="gotoPhone()"></div>
          <div class="open" @click="jumpUrl()"></div>
          <img class="img" src="../../assets/img/taocan.png" />
          <img
            class="close"
            @click="taocanModel = !taocanModel"
            src="../../assets/img/icon/icon_close.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navbar from "../../components/navbar/index.vue";
import { packageList } from "@/http/home";
export default {
  components: {
    navbar
  },
  data() {
    return {
      nav: {
        back: true,
        title: "プラン変更",
        chat: true
      },
      checkPack: "a",
      taocanModel: false,
      imgData: [],
      level: {},
      index: 0,
      notMore: false
    };
  },
  mounted() {
    this.getPackageList();
  },
  methods: {
    prev() {
      this.index = this.index - 2;
      this.notMore = false;
    },
    next() {
      if (this.index + 3 > this.imgData.length - 1) {
        this.notMore = true;
      } else {
        this.notMore = false;
      }
      this.index = this.index + 2;
    },
    getPackageList() {
      packageList().then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.imgData = data;
          if (data && data.length > 0) {
            for (let i in data) {
              if (data[i].use) {
                this.checkPackData(i, data[i]);
                break;
              }
            }
          }
        }
      });
    },
    checkPackData(i, item) {
      this.checkPack = i;
      this.level = item;
    },
    savePack() {},
    gotoPhone() {
      window.location.href = "tel://0120-668-625";
    },
    jumpUrl() {
      window.open(
        "https://www.neuralmarketing.co.jp/smartsketcherai_plan/",
        "_blank"
      );
    }
  }
};
</script>

<style>
.packagePage.aiPageBg {
  height: 100%;
  /* height: calc(100% - 40px); */
}
.packageContent {
  /* margin-top: 60px; */
  width: calc(100% - 30px);
  padding: 0 15px 0 15px;
  height: calc(100% - 10px);
  height: -webkit-calc(100% - 10px);
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
}
/* #app .packageContent .buttonBlue {
  position: absolute;
  left: 24px;
  bottom: 10px;
  width: calc(100% - 48px);
} */
.packageContent .imgBox {
  width: 100%;
  overflow: hidden;
  position: relative;
  /* display: flex;
  justify-content: space-between; */
}
.packageContent .imgBox .checkPackBox {
  background: linear-gradient(
      0deg,
      rgba(170, 255, 0, 0.2),
      rgba(170, 255, 0, 0.2)
    ),
    linear-gradient(
      180deg,
      rgba(167, 238, 60, 0.93) 0%,
      rgba(19, 216, 166, 0.4) 93%
    ),
    linear-gradient(180deg, #3bde8a 0%, #13d8a6 100%);
  background-blend-mode: hard-light, normal, normal;
  box-sizing: border-box;
  border: 4px solid;
  border-image: linear-gradient(180deg, #55bc00 2%, #03ad72 100%) 4;
}
.packageContent .imgBox .imgItem {
  width: calc(50% - 6px);
  height: 250px;
  margin-right: 12px;
  margin-bottom: 12px;
  border-radius: 8px;
  position: relative;
  background-color: #66b5ff;
  overflow: hidden;
  display: inline-block;
  position: relative;
}
.packageContent .imgBox .left,
.packageContent .imgBox .right {
  width: 44px;
  height: 44px;
  line-height: 44px;
  position: absolute;
  top: 50%;
  margin-top: -22px;
  z-index: 9;
  /* background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0.4) 100%); */
  cursor: pointer;
  color: #ffffff;
  text-align: center;
  background: #2b99ff;
  border-radius: 50%;
}
.packageContent .imgBox .left {
  left: 0;
  /* border-radius: 8px 0 0 8px; */
  /* background: linear-gradient(-270deg, #ffffff 0%, rgba(255, 255, 255, 0.4) 100%); */
}
.packageContent .imgBox .right {
  right: 0;
}
.packageContent .imgBox .van-icon {
  font-size: 20px;
  /* font-weight: bold; */
  /* color: #2b99ff; */
}
.packageContent .imgBox .imgItem:nth-child(2n) {
  margin-right: 0;
}
.packageContent .imgBox .img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.packageContent .imgBox .imgItem .new {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  width: 50px;
  height: 24px;
}
.packageContent .imgBox .imgItem .check {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 11;
  width: 32px;
  height: 32px;
}
.packageContent .pack {
  width: calc(50% - 6px);
  height: 250px;
  display: block;
  cursor: pointer;
}
.packageContent .tagBox {
  /* height: 158px; */
  border-radius: 12px;
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 32px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0);
  background: #ffffff;
  box-sizing: border-box;
}
.packageContent .tagBox .text {
  font-family: MediumFont;
  font-size: 18px;
  font-weight: normal;
  line-height: 22px;
  color: #232036;
}
.packageContent .tagBox .items {
  height: 36px;
  line-height: 36px;
  border-radius: 60px;
  padding: 0 8px;
  margin-top: 16px;
  background: rgba(43, 153, 255, 0.2);
  display: inline-block;
}
.packageContent .tagBox .items .icon {
  width: 20px;
  height: 20px;
  margin-right: 4px;
  display: inline-block;
  vertical-align: middle;
}
.packageContent .tagBox .items > div {
  font-family: RegularFont;
  display: inline-block;
  font-size: 12px;
}
.taocanPopup {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 91;
  left: 0;
  top: 0;
}
.taocanPopup .taocanContent {
  width: 86%;
  position: absolute;
  left: 7%;
  top: 50%;
  z-index: 95;
  margin-top: -250px;
}
.taocanPopup .taocanContent .img {
  width: 100%;
  height: 400px;
  position: relative;
}
.taocanPopup .taocanContent .close {
  width: 28px;
  height: 28px;
  display: block;
  margin: 22px auto 0 auto;
  cursor: pointer;
}
.taocanPopup .taocanContent .phone,
.taocanPopup .taocanContent .open {
  position: absolute;
  z-index: 99;
  left: 0;
  height: 60px;
  width: 100%;
  cursor: pointer;
}
.taocanPopup .taocanContent .phone {
  top: 36%;
}
.taocanPopup .taocanContent .open {
  top: 67%;
}
@media screen and (min-width: 1439px) {
  .packageContent {
    width: calc(100% - 30px); /* no*/
    padding: 0 15px; /* no*/
    min-height: calc(100% - 65px); /* no*/
  }
  .packageContent .imgBox .checkPackBox {
    border: 4px solid; /* no*/
    background: linear-gradient(
        0deg,
        rgba(170, 255, 0, 0.2),
        rgba(170, 255, 0, 0.2)
      ),
      linear-gradient(
        180deg,
        rgba(167, 238, 60, 0.93) 0%,
        rgba(19, 216, 166, 0.4) 93%
      ),
      linear-gradient(180deg, #3bde8a 0%, #13d8a6 100%);
    background-blend-mode: hard-light, normal, normal;
    box-sizing: border-box;
    border-image: linear-gradient(180deg, #55bc00 2%, #03ad72 100%) 4;
  }
  .packageContent .tagBox {
    border-radius: 12px; /* no*/
    padding: 16px; /* no*/
    margin-top: 16px; /* no*/
    margin-bottom: 32px; /* no*/
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0); /* no*/
  }
  .packageContent .tagBox .text {
    font-size: 18px; /* no*/
    line-height: 22px; /* no*/
  }
  .packageContent .tagBox .items {
    height: 36px; /* no*/
    line-height: 30px; /* no*/
    border-radius: 60px; /* no*/
    padding: 0 8px; /* no*/
    margin-top: 16px; /* no*/
    background: rgba(43, 153, 255, 0.2); /* no*/
  }
  .packageContent .tagBox .items .icon {
    width: 20px; /* no*/
    height: 20px; /* no*/
    margin-right: 4px; /* no*/
  }
  .packageContent .tagBox .items > div {
    font-size: 12px; /* no*/
  }

  .packageContent .imgBox .imgItem {
    width: calc(50% - 6px); /* no*/
    height: 330px; /* no*/
    margin-right: 12px; /* no*/
    margin-bottom: 12px; /* no*/
    border-radius: 8px; /* no*/
  }
  .packageContent .imgBox .left,
  .packageContent .imgBox .right {
    width: 44px; /* no*/
    height: 44px; /* no*/
    line-height: 40px; /* no*/
    margin-top: -22px; /* no*/
  }
  .packageContent .imgBox .van-icon {
    font-size: 20px; /* no*/
  }
  .packageContent .imgBox .img {
    width: 100%; /* no*/
  }
  .packageContent .imgBox .imgItem .new {
    width: 50px; /* no*/
    height: 24px; /* no*/
  }
  .packageContent .imgBox .imgItem .check {
    width: 32px; /* no*/
    height: 32px; /* no*/
  }
  .packageContent .pack {
    height: 320px; /* no*/
  }
  .taocanPopup .taocanContent {
    width: 420px; /* no*/
    margin-top: -350px; /* no*/
    margin-left: -222px; /* no*/
    left: 50%;
  }
  .taocanPopup .taocanContent .close {
    width: 28px; /* no*/
    height: 28px; /* no*/
    margin: 22px auto 0 auto; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/unlockPackage.vue